export class Rapport {
    constructor(public id: string  ,public name : string ) { }
  }